import { Box, LoadingOverlay } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { accountApi } from '@/api/accountApi'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { AuthLayout } from '@/components/layout/AuthLayout/AuthLayout'
import { showToast } from '@/theme/notifications'
import { LinkExpired } from './LinkExpired/LinkExpired'

type LinkExpiredHandlerProps = {
  uid: string
  token: string
}

export const LinkExpiredHandler = ({ uid, token }: LinkExpiredHandlerProps) => {
  const intl = useIntl()

  const { mutate, isPending } = useMutation({
    mutationFn: accountApi.sendVerifyEmail,
    onSuccess: () => {
      showToast(intl.formatMessage({ id: 'emailSent' }), 'success')
    },
    onError: (err) => {
      showToast(
        extractErrorMessage(
          err,
          intl.formatMessage({ id: 'emailFailedToSend' })
        ),
        'error'
      )
    }
  })

  const handleResendEmail = () => {
    mutate({
      uid,
      token
    })
  }

  return (
    <AuthLayout variant="large">
      <Box>
        <LoadingOverlay visible={isPending} />

        <LinkExpired onResendEmail={handleResendEmail} />
      </Box>
    </AuthLayout>
  )
}
